import { render, staticRenderFns } from "./EvidenceList.vue?vue&type=template&id=8cf1a940&scoped=true&"
import script from "./EvidenceList.vue?vue&type=script&lang=ts&"
export * from "./EvidenceList.vue?vue&type=script&lang=ts&"
import style0 from "./EvidenceList.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./EvidenceList.vue?vue&type=style&index=1&id=8cf1a940&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf1a940",
  null
  
)

export default component.exports